import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css';
import './reset.local.scss';
import './index.scss';
import AppContainer from './AppContainer';
import { BrowserRouter as Router } from 'react-router-dom';

ReactDOM.render(
    <Router>
        <AppContainer />
    </Router>,
    document.getElementById('root')
);